import { render, staticRenderFns } from "./single_ans.vue?vue&type=template&id=954f5c3e&scoped=true&"
import script from "./single_ans.vue?vue&type=script&lang=js&"
export * from "./single_ans.vue?vue&type=script&lang=js&"
import style0 from "./single_ans.vue?vue&type=style&index=0&id=954f5c3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954f5c3e",
  null
  
)

export default component.exports